<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/system/modules">{{$t('modules')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card n_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="blue label-control">{{$t('name')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="model.Name" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="blue label-control">{{$t('barcode')}}</label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.Code" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="blue label-control">{{$t('icon')}}</label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.Icon" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="blue label-control">{{$t('sort')}}</label>
                                        <div>
                                            <input type="number" class="form-control form-control-sm" v-model="model.Sort" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="blue label-control">{{$t('url')}}</label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.Url" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="blue label-control">{{$t('lang_key')}}</label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.LangKey" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>
                                            <input type="checkbox" v-model="model.Enabled" /> {{$t('enabled')}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            model: {
                Name: '',
                Code: '',
                Icon: '',
                Sort: 0,
                Enabled: true
            },
            title: this.$t('module_create'),
            actionLink: 'system/module/save'
        }
    },
    created(){
        var id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.findById(id);
            this.actionLink = 'system/module/update';
            this.title = this.$t('module_update');
        }
    },
    methods: {
        findById(id){
            var loading = this.$loading.show();
            this.$api().post('system/module/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.model = res.data.Json.Module;
                }
            }).finally(function() { loading.hide(); });
        },
        onSave(){
            var loading = this.$loading.show();
            this.$api().post(this.actionLink, this.model).then(res => {
                if(this.$isValid(res)){
                    this.$router.go(-1);
                }
            }).finally(function() { loading.hide(); });
        }
    }
}
</script>